import { useContext } from 'react';

import RemoteAccessBuildingAuditContext from '@totem/components/services/remoteAccess/v2/buildingAudit/RemoteAccessBuildingAuditContext';

const RemoteAccessBuildingAuditPageTitle = () => {
  const { buildingName } = useContext(RemoteAccessBuildingAuditContext);

  if (!buildingName) {
    return 'Remote Access User Audit';
  }

  return `Remote Access User Audit: ${buildingName}`;
};

export default RemoteAccessBuildingAuditPageTitle;
